import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const JuniorHigh = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Junior High
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex max-w-fit'>
              <p className='text-black sm:text-justify md:text-xl'>
                Junior high school students in grades 7 to 9 with a focus on
                English Language arts, mathematical science and social studies.
                Our teachers help students assemble and apply their knowledge
                and help develop employability skills while supporting students
                to achieve a seamless transition into the fast-paced environment
                of senior high school.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/junior.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default JuniorHigh;
